// src/modules/app-views/invoices/pages/Init/components/tableColumns/issueDateColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import invoicesService from 'modules/app-views/invoices/service';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the issue date column.
// options.requireSefaz: true (default) — hides date if not processed by SEFAZ (invoices).
//                       false (goodsReceipt) — always shows date.
function issueDateColumn(buildColumnProps, options = {}) {
  const { requireSefaz = true } = options;

  return {
    title: translateX('emission'),
    dataIndex: 'issueDate',
    ...buildColumnProps('issueDate', { sort: true, search: false }),
    width: 110,
    align: 'center',
    render: (_, record) => {
      const date = record?.issueDate;
      const isProcessed = requireSefaz ? invoicesService.isProcessedBySefaz(record?.status) : true;
      if (!date || !isProcessed) return '—';
      return dayjs(date).format('DD/MM/YYYY');
    },
  };
}

export default issueDateColumn;
